<template>
    <div :class="!incomeId ? 'app-body' : ''">
        <bread-crumb v-if="!incomeId"></bread-crumb>
        <el-card class="el-main a-fs-14 comfirmed">
            <div class="comfirmed-top a-flex-rfsc">
                <div class="title a-fs-16">{{ detail.name }}</div>
                <el-tag class="a-ml-15" v-if="detail.stateText == '异议'" type="danger">{{ detail.stateText }}</el-tag>
                <el-tag class="a-ml-15" v-else>{{ detail.stateText }}</el-tag>
                <el-tag class="a-ml-08" type="danger" v-if="detail.confirmStatus && !isStation">{{ util.initDic(detail.confirmStatus, 'incomeConfirmStatus') }}</el-tag>
            </div>
            <!-- 变更进度 -->
            <div class="a-flex-cfsfs comfirmed-box change-progress" v-if="detail.state == 1 || detail.confirmStatus==6">
                <div class="title a-fs-16">{{ detail.confirmStatus == 1 ? '变更进度' : '创建进度' }}</div>
                <!-- 步骤条 -->
                <div class="progress-steps a-flex-rfsc" style="width: 600px;">
                    <div v-for="(step, index) in progressSteps" :key="index" class="progress-step a-flex-ccc">
                        <div class="step-line-wrap a-flex-rfsc">
                            <div class="step-line" :class="index === 0 ? 'step-line-none' : (index <= currentStepIndex ? 'step-line-active' : '')"></div>
                            <div class="step-icon" :class="index < currentStepIndex ? 'step-done' : (index === currentStepIndex ? 'step-active' : 'step-pending')">
                                <i v-if="index < currentStepIndex" class="el-icon-check"></i>
                                <i v-else-if="index === currentStepIndex" class="el-icon-time"></i>
                                <span v-else></span>
                            </div>
                            <div class="step-line" :class="index === progressSteps.length - 1 ? 'step-line-none' : (index < currentStepIndex ? 'step-line-active' : '')"></div>
                        </div>
                        <div class="step-label" :class="index === currentStepIndex ? 'step-label-active' : ''">{{ step }}</div>
                    </div>
                </div>
                <!-- 审核流程 -->
                <approval-timeline class="a-mt-16" :instance-id="detail.instanceId" v-if="company.isSystem == 1" />
            </div>
            <div class="a-flex-cfsfs comfirmed-box" v-if="detail.stateText == '异议'">
                <div class="title a-fs-16">审核结果</div>
                <div class="a-w-100 a-flex-rfsc a-flex-wrap comfirmed-box-item ">
                    <div>
                        <span>审核结果</span>
                        <span>拒绝</span>
                    </div>
                    <div>
                        <span>拒绝原因</span>
                        <span>{{ objectionMessage }} </span>
                    </div>
                </div>
            </div>
            <div class="a-flex-cfsfs comfirmed-box">
                <div class="title a-fs-16">基本信息</div>
                <div class="a-w-100 a-flex-rfsc a-flex-wrap comfirmed-box-item ">
                    <div>
                        <span>所属商户</span>
                        <span>{{ detail.companyName }}</span>
                    </div>
                    <div>
                        <span>最大可分配收益</span>
                        <span>{{ companyMaxRate }}%</span>
                    </div>
                    <div>
                        <span>拟定站点定价</span>
                        <span>{{ detail.defaultPlanName }}</span>
                    </div>
                    <div>
                        <span>平台服务费</span>
                        <span>{{ util.numFormat(detail.serviceFee) }}元每{{ serviceTime[detail.serviceFeeTime] }}</span>
                    </div>
                </div>
            </div>
            <div class="a-flex-cfsfs comfirmed-box" v-if="electricInfo">
                <div class="title a-fs-16">电费信息</div>
                <div class="a-w-100 a-flex-rfsc a-flex-wrap comfirmed-box-item " >
                    <div>
                        <span>电费缴纳方</span>
                        <span>{{ electricInfo.companyName || '-' }}</span>
                    </div>
                    <div>
                        <span>电费项目名称</span>
                        <span>{{ electricInfo.name || '-' }}</span>
                    </div>
                    <div>
                        <span>电费价格</span>
                        <span>{{ electricInfo.unitPrice || '-' }}元/kwh</span>
                    </div>
                    <div>
                        <span>电费收取方式</span>
                        <span>{{ electricInfo.chargeFeeType | initDic(chargeFeeTypeDic) }}</span>
                    </div>
                    <div>
                        <span>电费收款方</span>
                        <span>{{ electricInfo.chargePayeeType | initDic(chargePayeeTypeDic) }}</span>
                    </div>
                    <div v-if="electricInfo.chargePayeeType == 2">
                        <span>收款物业方</span>
                        <span>
                            <span v-for="(item, index) in electricInfo.propertyList" :key="index">
                                {{ item.propertyName ? item.propertyName : '-' }}，占比{{ item.rate }}%<span v-if="index < electricInfo.propertyList.length - 1">；</span>
                            </span>
                            <span v-if="!electricInfo.propertyList || !electricInfo.propertyList.length">-</span>
                        </span>
                    </div>
                    <div>
                        <span>默认服务费用</span>
                        <span>{{ electricInfo.serviceUnitPrice || '-' }}元</span>
                    </div>
                    <div>
                        <span>账单默认备注</span>
                        <span>{{ electricInfo.remark || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="a-flex-cfsfs comfirmed-box" v-if="detail.rateType == 2">
                <div class="title a-fs-16">分成比例</div>
                <div class="comfirmed-box-item a-w-100 a-flex-wrap ">
                    <div>
                        <span>分成模式</span>
                        <span>根据收益浮动</span>
                    </div>
                    <div v-if="detail.payPlatform">
                        <span class="a-c-second">收款钱包</span>
                        <span class="a-ml-15">{{ util.initDic(detail.payPlatform.servicePlatform, 'servicePlatform') }}</span>
                    </div>
                    <div v-if="detail.payPlatform && detail.payPlatform.servicePlatform == 1">
                        <span class="a-c-second">收款商户</span>
                        <span class="a-ml-15">{{ detail.payPlatform.uniCompanyName }}</span>
                    </div>
                </div>
                <div class="bilibox a-flex-ccsb " v-for="(item, index) in incomeList" :key="item.id || index">
                    <div class="bilibox-title ">
                        <div class="a-flex-rfsc">
                            <span class="">商户</span>
                            <span class="a-flex-1" style="margin-left:-50px;">{{ item.targetCompanyName }}</span>
                        </div>
                        <div>
                            <span>试运行30天分成</span>
                            <span>{{ item.rate / 100 }}%</span>
                        </div>

                    </div>
                    <div class="topone">
                        <div>连续30天平均单桩收益</div>
                        <div>分成比例</div>
                    </div>
                    <div v-for="(oitem, oindex) in item.list" :key="oindex">
                        <div>
                            <span v-if="oitem.minAmount || oitem.minAmount == 0">{{
                                    util.numFormat(oitem.minAmount)
                            }}&le;</span>
                            单桩日均收益
                            <span v-if="oitem.maxAmount">&lt;{{ util.numFormat(oitem.maxAmount)
                            }}</span>
                        </div>

                        <span>{{ oitem.rate / 100 }}%</span>
                    </div>
                    <div class="child-rate-list" v-if="item.childList && item.childList.length">
                        <div class="child-rate-item child-rate-item--float" v-for="(child, cIndex) in item.childList" :key="'child-' + cIndex">
                            <div class="child-rate-col">
                                <span class="child-rate-label">二级商户</span>
                                <span class="child-rate-name">{{ child.targetCompanyName }}</span>
                            </div>
                            <div class="child-rate-ranges" v-if="child.rangeDetail && child.rangeDetail.length">
                                <div class="child-rate-range" v-for="(oitem, oindex) in child.rangeDetail" :key="oindex">
                                    <span class="child-rate-range-text">
                                        <span v-if="oitem.minAmount || oitem.minAmount == 0">{{ util.numFormat(oitem.minAmount) }}&le;</span>
                                        单桩日均收益
                                        <span v-if="oitem.maxAmount">&lt;{{ util.numFormat(oitem.maxAmount) }}</span>
                                    </span>
                                    <span class="child-rate-value">{{ oitem.rate / 100 }}%</span>
                                </div>
                            </div>
                            <div class="child-rate-col" v-else-if="child.rate">
                                <span class="child-rate-label">分成比例</span>
                                <span class="child-rate-value">{{ child.rate / 100 }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-flex-cfsfs comfirmed-box" v-else>
                <div class="title a-fs-16">分成比例</div>
                <div class="comfirmed-box-item a-w-100  a-flex-wrap ">
                    <div>
                        <span>分成模式</span>
                        <span>固定收益比例</span>
                    </div>
                    <div v-if="detail.payPlatform">
                        <span class="a-c-second">收款钱包</span>
                        <span class="a-ml-15">{{ util.initDic(detail.payPlatform.servicePlatform, 'servicePlatform') }}</span>
                    </div>
                    <div v-if="detail.payPlatform && detail.payPlatform.servicePlatform == 1">
                        <span class="a-c-second">收款商户</span>
                        <span class="a-ml-15">{{ detail.payPlatform.uniCompanyName }}</span>
                    </div>
                </div>
                <div v-for="(item, index) in (detail.targetList || [])" :key="'p-' + (item.id || index)" class="a-w-100">
                    <div class="comfirmed-box-item a-w-100 a-flex-rfsc a-flex-wrap rate-primary-row">
                        <div>
                            <span>商户</span>
                            <span>{{ item.targetCompanyName }}</span>
                        </div>
                        <div>
                            <span>分成比例</span>
                            <span>{{ item.rate / 100 }}%</span>
                        </div>
                    </div>
                    <div class="child-rate-list" v-if="item.childList && item.childList.length">
                        <div class="child-rate-item" v-for="(child, cIndex) in item.childList" :key="'c-' + (item.id || index) + '-' + (child.id || cIndex)">
                            <div class="child-rate-col">
                                <span class="child-rate-label">二级商户</span>
                                <span class="child-rate-name">{{ child.targetCompanyName }}</span>
                            </div>
                            <div class="child-rate-col">
                                <span class="child-rate-label">分成比例</span>
                                <span class="child-rate-value">{{ child.rate / 100 }}%</span>
                            </div>
                            <div class="child-rate-col"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-flex-cfsfs comfirmed-box">
                <div class="title a-fs-16">项目合同</div>
                <el-table :data="contactList" style="margin-top: 16px;">
                    <el-table-column prop="startDate" label="开始日期"></el-table-column>
                    <el-table-column prop="endDate" label="结束日期"></el-table-column>
                    <el-table-column prop="startTimeText" label="附件">
                        <template slot-scope="{ row }">
                            <el-link type="primary" :underline='false' @click="handlePreviewFile(row)">{{ row.contractFile }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="endTimeText" label="合同说明">
                        <template slot-scope="{ row }">
                            <span>{{ row.contractNote || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stateText" label="操作人">
                        <template slot-scope="{ row }">
                            <span>{{ row.operateName || '-' }} {{ row.operatePhone || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="operateTime" label="操作时间"></el-table-column>
                </el-table>
            </div>
            <!-- <div class="a-line-t-e0 footerBox" v-if="!incomeId"> -->
            <div class="a-line-t-e0 footerBox_p">
                <template v-if="checkButton">
                    <el-button type="primary" class="a-ml-24 a-mt-15 myblue" @click="onSubmit">
                        &nbsp;&nbsp;&nbsp;确认&nbsp;&nbsp;&nbsp;</el-button>
                    <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" type="danger"
                        @click="dialogFormVisible = true">
                        &nbsp;&nbsp;&nbsp;异议&nbsp;&nbsp;&nbsp;
                    </el-button>
                </template>
                <template v-if="editButton">
                    <!-- <el-button type="primary" class="a-ml-24 a-mt-15 myblue" v-if="$_has(26) && company.isSystem && (userInfo.dataPermission == 99 || userInfo.dataPermission == 88)" @click="handlerEdit">
                        &nbsp;&nbsp;&nbsp;修改&nbsp;&nbsp;&nbsp;</el-button> -->
                    <el-button type="primary" class="a-ml-24 a-mt-15 myblue" v-if="detail.state == 4 && !detail.isChanging && $_has(26) && company.isSystem && (userInfo.dataPermission == 99 || userInfo.dataPermission == 88)" @click="handlerEdit">
                        &nbsp;&nbsp;&nbsp;修改&nbsp;&nbsp;&nbsp;</el-button>
                    <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" type="danger" @click="revoke" plain>
                        &nbsp;&nbsp;&nbsp;撤销&nbsp;&nbsp;&nbsp;
                    </el-button>
                </template>

            </div>

        </el-card>

        <el-dialog title="异议" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="form">
                <el-form-item>
                    <el-input type="textarea" v-model="form.objection" clearable maxlength="150" show-word-limit
                        placeholder="请输入异议内容" :autosize="{ minRows: 6, maxRows: 10 }">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click.native="objection">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex';
import util from '../../utils/util'
import ProjectDetailHistoryIncome from './project-detail-history-income.vue'
import ApprovalTimeline from './child/approval-timeline.vue'
import { Table } from 'element-ui';
export default {
    props: {
        incomeId: {
            type: Number
        },
        isStation: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ProjectDetailHistoryIncome,
        ApprovalTimeline
    },
    data() {
        return {
            util: util,
            form: {
                objection: ''
            },
            dialogFormVisible: false,
            detail: {},
            id: "",
            targetList: [],
            incomeList: [],
            companyMaxRate: 100,
            serviceTime: ['', '月', '季度', '年'],
            checkButton: false,
            editButton: false,
            objectionMessage: '',
            electricInfo: null,
            chargeFeeTypeDic: [],
            chargePayeeTypeDic: [],
            contactList: [],
            progressSteps: ['发起方案', '收益方确认', '待审批', '已生效'],
        }
    },
    watch: {
        incomeId: {
            handler(val) {
                if (val) {
                    this.getDetail();
                }
            }
        }
    },
    created() {
        if (this.$route.query.id) {
            this.getDetail()
        }
        this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        this.$getDic('chargePayeeType','select').then(res=>{ this.chargePayeeTypeDic = res; })
    },
    computed: {
        ...mapState({
            company: state => state.company.company,
            userInfo: state => state.user.user,
        }),
        currentStepIndex() {
            if(this.detail.instanceId) {
                return 2
            }else {
                return 1
            }
        },
    },
    methods: {
        getDetail() {
            this.id = this.$route.query.id || this.incomeId

            this.$Axios._get({
                url: this.isStation ? this.$Config.apiUrl.getIncomeDetailInfo : this.$Config.apiUrl.gitEditIncomeDetailInfo,
                params: {
                    incomeId: parseInt(this.id)
                }
            }).then((res) => {
                if (res.result.code == 0) {
                    let that = this
                    let data = res.result.data
                    this.detail = res.result.data
                    if (data.companyId == this.company.id) {
                        this.editButton = true
                        this.checkButton = false
                    }
                    if (res.result.data.contractFile) {
                        let d = data.contractFile.split('/')
                        this.detail.contractFileText = d[d.length - 1];
                    }


                    // let num = this.detail.targetList.filter((item, index) => {
                    //     return item.targetCompanyId == this.detail.companyId
                    // }).map((oitem, oindex) => {
                    //     return oitem.rate
                    // }).reduce(function (prev, cur, index, arr) {
                    //     console.log(prev, cur, index);
                    //     return parseInt(prev) + parseInt(cur);
                    // })
                    // this.detail.merchantIncome = num / 100

                    this.companyRate(res.result.data.companyId)

                    // 获取电费详情
                    if (data.projectId) {
                        this.getPropertyDetail(data.projectId)
                    }

                    if (data.changeId) {
                        this.handleGetContact(data.changeId)
                    }
                    
                    this.targetList = data.targetList.map((item, index) => {
                        this.markConfirmStatus(item)
                        ;(item.childList || []).forEach(child => {
                            this.markConfirmStatus(child)
                        })
                        if (item.testRun != 1) {
                            if (data.rangeList) {
                                data.rangeList.map((oitem, oindex) => {

                                    if (item.rateRangeId == oitem.id) {
                                        item.maxAmount = oitem.maxAmount,
                                            item.minAmount = oitem.minAmount
                                    }
                                })
                            }

                        }
                        return item
                    })

                    function unique(arr, val) {
                        const res = new Map()
                        return arr.filter(item => !res.has(item[val]) && res.set(item[val], 1))
                    }


                    let list = unique(that.targetList, 'targetCompanyId')
                    let result = list.map((item, index) => {
                        let olist = that.targetList.filter((oitem, oindex) => {
                            return oitem.targetCompanyId == item.targetCompanyId
                        })

                        let c;
                        olist.map((item, index) => {

                            if (!!item.testRun) {
                                if (!!item.rate) {
                                    c = item.rate
                                }
                                olist.splice(index, 1)
                            }

                        })

                        let obj = {
                            targetCompanyId: item.targetCompanyId,
                            targetCompanyName: item.targetCompanyName,
                            rate: c || 0,
                            list: olist,
                            childList: item.childList || []
                        }

                        return obj
                    })
                    this.incomeList = result;

                }
            })
        },
        handleGetContact (incomeId) {
            this.$Axios._get({
                url: this.$Config.apiUrl.incomeContractList,
                params: {
                    incomeId: incomeId
                },
            }).then(({data}) => {
                this.contactList = data
            });
        },
        handleClose(done) {
            this.dialogFormVisible = false
        },
        //提出异议
        objection() {
            this.dialogFormVisible = false
            this.$Axios._post({
                url: this.$Config.apiUrl.notAgreeIncome,
                params: {
                    incomeId: this.detail.id,
                    message: this.form.objection
                },
            }).then((res) => {
                if (res.result.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    })
                    this.$route.meta.hash = "del";
                    this.$router.replace({
                        path: '/project/project-list'
                    })
                }
            });
        },
        companyRate(id) {
            let that = this

            this.$Axios._get({
                url: this.$Config.apiUrl.getCompanyMaxRate,
                params: {
                    companyId: id
                }
            }).then((res) => {
                that.companyMaxRate = res.result.data / 100

            })
        },
        getPropertyDetail(id) {
            this.$Axios._post({
                url: this.$Config.apiUrl.electricInfo,
                method: "post",
                params: {
                    id: id
                }
            })
            .then(res=>{
                if (res.result.code == 0) {
                    this.electricInfo = {
                        ...res.result.data,
                        chargeFeeType: JSON.stringify(res.result.data.chargeFeeType),
                        chargePayeeType: JSON.stringify(res.result.data.chargePayeeType),
                        electricFeeType: JSON.stringify(res.result.data.electricFeeType),
                        unitPrice: res.result.data.unitPrice ? this.$decimal.decimal_except(res.result.data.unitPrice, 100) : '',
                        serviceUnitPrice: res.result.data.serviceUnitPrice ? this.$decimal.decimal_except(res.result.data.serviceUnitPrice, 100) : '',
                    }
                    if (this.electricInfo.chargePayeeType == 2 && this.electricInfo.propertyList && this.electricInfo.propertyList.length) {
                        this.electricInfo.propertyList = this.electricInfo.propertyList.map(item=>{
                            return {
                                ...item,
                                rate: Number((item.rate/100).toFixed(2))
                            }
                        })
                    }
                }
            })
            .catch(err=>{
                console.log(err);
            })
        },
        revoke() {
            this.$confirm('确定撤销该项目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.$Axios._get({
                    url: this.$Config.apiUrl.cancelIncome,
                    params: {
                        incomeId: this.detail.id
                    }
                }).then((res) => {
                    if (res.result.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '撤销成功!'
                        });
                        setTimeout(() => {
                            this.$router.push({
                                path: '/project/project-list'
                            })
                        }, 1000)
                    }

                })




            }).catch(() => {

            });
        },
        handlerEdit() {
            this.$router.push({
                path: '/project/project-add',
                query: {
                    incomeId: this.detail.id
                }
            })
        },
        //确认方案
        onSubmit() {
            this.$Axios._get({
                url: this.$Config.apiUrl.confirmIncome,
                params: {
                    incomeId: this.detail.id
                }
            }).then((res) => {
                if (res.result.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '确认成功!'
                    });
                    setTimeout(() => {
                        this.$router.push({
                            path: '/project/project-list'
                        })
                    }, 1000)
                }

            })
        },
        markConfirmStatus(item) {
            if (item.targetCompanyId == this.company.id && item.status == 0) {
                this.checkButton = true
            }
            if (item.status == 2) {
                this.objectionMessage = item.message
            }
        },
        handlePreviewFile (row) {
            if(row.contractFile) {
                window.open(row.contractFile, '_blank')
            }else {
                this.$message.warning('暂无可预览文件')
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.comfirmed {
    position: relative;

    &-top {
        padding: 24px 24px 16px;
        border-bottom: 1px solid #EBF0F5;
        font-weight: bold;
    }

    &-box {
        padding: 24px;
        margin-top: 32px;

        &:nth-child(2) {
            margin-top: 0;
        }

        .title {
            font-weight: bold;
        }

        &-item {
            >div {
                width: 33.3%;
                display: flex;

                >* {
                    font-size: 14px;
                    margin-top: 16px;
                    line-height: 22px;
                    display: flex;


                    &:nth-of-type(1) {
                        color: #606366;
                        min-width: 100px;

                    }

                    &:nth-of-type(2) {
                        color: #303133;
                        margin-left: 16px;

                    }
                }
            }
        }
    }
}




.bilibox {
    font-size: 14px;
    padding: 0 16px;
    border: 1px solid #DADDE0;
    width: 50%;
    margin-top: 16px;
    margin-bottom: 8px;
    padding-bottom: 14px;

    >div:not(.child-rate-list) {
        >* {
            width: 50%;
            text-align: center;
        }

        display: flex;

        justify-content: center;
        align-items: center;
        padding: 11px 0;
        border-bottom: 1px solid #EBF0F5;

        &:nth-last-child(1) {
            border-bottom: none;
        }


    }

    &-title {
        padding: 24px 0 !important;
        border: none;

        >div {
            span {
                &:nth-of-type(1) {
                    color: #797979;
                    margin-right: 16px;
                }
            }
        }
    }

    .topone {
        background: #F5F7FA;
        color: #797979;
        border: none;

    }
}

.child-rate-list {
    width: 100%;
    padding: 0 0 16px 36px;
    box-sizing: border-box;
    position: relative;
}

.child-rate-list::before {
    content: '';
    position: absolute;
    left: 14px;
    top: 0;
    bottom: 24px;
    width: 1px;
    background: #E4E7ED;
}

.child-rate-item {
    display: flex;
    align-items: center;
    background: #F7F8FA;
    border: 1px solid #EEF0F3;
    border-radius: 4px;
    padding: 10px 16px;
    margin-top: 8px;
    position: relative;
    box-sizing: border-box;
}

.child-rate-item::before {
    content: '';
    position: absolute;
    left: -22px;
    top: 50%;
    width: 22px;
    height: 1px;
    background: #E4E7ED;
}

.child-rate-col {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
}

.child-rate-label {
    color: #909399;
    margin-right: 12px;
    flex-shrink: 0;
    font-size: 14px;
}

.child-rate-name,
.child-rate-value {
    color: #303133;
    font-size: 14px;
}

.child-rate-item--float {
    flex-direction: column;
    align-items: stretch;
}

.child-rate-ranges {
    margin-top: 8px;
}

.child-rate-range {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    color: #606266;
    font-size: 13px;
}

.child-rate-range-text {
    color: #909399;
}

/deep/ .el-card__body {
    padding: 0;
    padding-bottom: 150px;
}

/deep/ .el-main {
    padding: 0;
}

.footerBox_p {
    // left: 255px;
    // right: 43px;
    // position: fixed;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding-bottom: 24px;
    margin-bottom: 0;
}
// 变更进度
.change-progress {
    .progress-steps {
        margin-top: 16px;
        justify-content: center;

        .progress-step {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;

            .step-line-wrap {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .step-line {
                flex: 1;
                height: 1px;
                background: #DADDE0;

                &-active {
                    background: #007AFF;
                }

                &-none {
                    background: transparent;
                }
            }

            .step-icon {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                border: 1px solid #DADDE0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                flex-shrink: 0;
                background: #fff;

                &.step-done {
                    background: #007AFF;
                    border-color: #007AFF;
                    color: #fff;
                }

                &.step-active {
                    border-color: #007AFF;
                    color: #007AFF;
                    background: #fff;
                }

                &.step-pending {
                    border-color: #DADDE0;
                    color: #DADDE0;
                    background: #fff;
                }
            }

            .step-label {
                margin-top: 8px;
                font-size: 12px;
                color: #909399;
                text-align: center;

                &-active {
                    color: #007AFF;
                    font-weight: bold;
                }
            }
        }
    }

}
</style>